import { FC } from "react";
import { RefetchOptions } from "@tanstack/react-query";

import { ErrorComponent } from "../../Errors";

interface Props {
  error: Error | null;
  refetch?: (options?: RefetchOptions | undefined) => Promise<unknown>;
}

export const MainPageLimitError: FC<Props> = ({ error, refetch }) => {
  return (
    <ErrorComponent
      error={error}
      refetch={refetch}
      showGoHomeButton={false}
      techInfoBgColor="white"
    />
  );
};
